'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a checkbox along with a specified string label.
 * @extends {Component}
 */
var StaticComponent = function (_React$Component) {
  _inherits(StaticComponent, _React$Component);

  function StaticComponent() {
    _classCallCheck(this, StaticComponent);

    return _possibleConstructorReturn(this, (StaticComponent.__proto__ || Object.getPrototypeOf(StaticComponent)).apply(this, arguments));
  }

  _createClass(StaticComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.FormControl.Static,
        null,
        this.props.staticValue ? this.props.staticValue : this.props.field.value
      );
    }
  }]);

  return StaticComponent;
}(_react2.default.Component);

StaticComponent.propTypes = {
  field: _react2.default.PropTypes.object,
  staticValue: _react2.default.PropTypes.object
};
StaticComponent.defaultProps = {};
exports.default = StaticComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/StaticComponent.jsx
// module id = 404
// module chunks = 0